import { graphql } from "@/gql";

export const relocationStatusCountsQuery = graphql(`
  query RelocationStatusCountsQuery($supplierId: ID, $type: [RelocationType!]) {
    relocationStatusCounts(supplierId: $supplierId, type: $type) {
      status
      count
    }
  }
`);
